<template>
  <div class="certificates">
    <h2>Certificates</h2>
    <div class="row">
      <div class="certificates__block col-xs-6">
        <h3 class="list__header">{{ missingBatches.length }} Missing batches</h3>
        <ul class="list__items">
          <li class="list__item" v-bind:key="batch" v-for="batch in missingBatches">
            <span class="list__content">{{ batch }}</span>
          </li>
        </ul>

        <h3 class="list__header">{{ draftBatches.length }} Draft batches</h3>
        <ul class="list__items">
          <li class="list__item" v-bind:key="batch" v-for="batch in draftBatches">
            <span class="list__content">{{ batch }}</span>
          </li>
        </ul>

      </div>
      <div class="certificates__block col-xs-6">
        <h3 class="list__header">
          {{ productsMissingCerts.length }} ERP Products missing Cert Types
        </h3>
        <ul class="list__items">
          <li class="list__item" v-bind:key="batch" v-for="batch in productsMissingCerts">
            <span class="list__content">{{ batch }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppCertificates',
  props: [
    'missingBatches',
    'draftBatches',
    'productsMissingCerts',
  ],
};
</script>
